// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__30GAk","disabled":"FileBtn_disabled__1D6Op","warn":"FileBtn_warn__2InZz","fade":"FileBtn_fade__3uXPN"};